var map = {
	"./STB-logo.png": 4783,
	"./background.png": 4989,
	"./bhd-logo-0.png": 2367,
	"./bhd-logo-1.png": 9007,
	"./bhd-logo.png": 5331,
	"./cancel.png": 6501,
	"./dark-wave-back.png": 4540,
	"./first logo simple.png": 6693,
	"./horizontal-logo-text.png": 9050,
	"./second logo simple.png": 7751,
	"./second logo w text.png": 6672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2045;